import type { ParsedArgs } from '../args.js';
import { flag } from '../args.js';
import { catalogForPrefix } from '../catalog.js';
import type { CommandResult } from '../output.js';

export function catalogCommand(args: ParsedArgs): CommandResult {
  const entries = catalogForPrefix(flag(args.flags, 'filter'));
  return {
    data: {
      schemaVersion: 1,
      commands: entries,
    },
    human: entries.map((entry) => `${entry.path}\t${entry.effect}\t${entry.summary}`).join('\n'),
  };
}
